<template>
  <div>
    <div class="tw-pb-2 tw-text-lg">
      {{ this.$gettext("NEGOTIATION") }}
      <q-separator />
    </div>
    <div class="tw-py-2">
      {{ this.$gettext("TRADING_FEES") }}
      <q-separator />
    </div>
    <div class="tw-flex tw-w-full tw-gap-4">
      <jt-input
        class="tw-w-1/3"
        ref="input"
        name="jtsearch-input"
        type="number"
        :float-label="$gettext('INSTALLMENT_QUANTITY')"
        v-model="dadosForm.installmentQuantity"
        @focus="blockContinueSteep"
        :required="isInvalidInstallmentQuantity"
      />
      <jt-input
        class="tw-w-1/3"
        ref="input"
        name="jtsearch-input"
        type="date"
        format="DD/MM/YYYY"
        :float-label="$gettext('FIRST_INSTALLMENT_DUE')"
        v-model="dadosForm.firstInstallmentDue"
        @focus="blockContinueSteep"
        :required="isInvalidFirstInstallmentDue"
      />
      <div class="tw-w-1/3" />
    </div>
    <div class="tw-py-2">
      {{ this.$gettext("NEGOTIATION_DISCOUNT") }}
      <q-separator />
    </div>
    <div class="tw-flex tw-w-full tw-gap-4">
      <jt-input
        class="tw-w-1/3"
        ref="input"
        name="jtsearch-input"
        type="number"
        :float-label="$gettext('INTEREST_DISCOUNT')"
        :required="isInvalidInterestDiscount"
        :stack-label="$gettext('VALUE_IN_PERCENTAGE')"
        @blur="blurPorcent(dadosForm.interestDiscount, 'interestDiscount')"
        v-model="dadosForm.interestDiscount"
        @focus="blockContinueSteep"
      />
      <jt-input
        class="tw-w-1/3"
        ref="inputFineDiscount"
        name="jtsearch-input"
        type="number"
        :float-label="$gettext('FINE_DISCOUNT')"
        :required="isInvalidFineDiscount"
        :stack-label="$gettext('VALUE_IN_PERCENTAGE')"
        @blur="blurPorcent(dadosForm.fineDiscount, 'fineDiscount')"
        v-model="dadosForm.fineDiscount"
        @focus="blockContinueSteep"
      />
      <jt-input
        class="tw-w-1/3"
        ref="inputCorrectionDiscount"
        name="jtsearch-input"
        type="number"
        :float-label="$gettext('CORRECTION_DISCOUNT')"
        :required="isInvalidCorrectionDiscount"
        :stack-label="$gettext('VALUE_IN_PERCENTAGE')"
        @blur="blurPorcent(dadosForm.correctionDiscount, 'correctionDiscount')"
        v-model="dadosForm.correctionDiscount"
        @focus="blockContinueSteep"
      />
    </div>
    <div class="tw-w-full tw-flex tw-justify-center">
      <q-btn @click="recalculate" class="tw-bg-skyWaste tw-text-white">{{
        $gettext("RECALCULATE")
      }}</q-btn>
    </div>

    <div class="tw-py-2">
      {{ this.$gettext("NEGOTIATION_SUMMARY") }}
      <q-separator />
    </div>
    <div class="tw-flex tw-gap-6 tw-p-4">
      <div class="tw-w-1/3 custom-border tw-p-2">
        <div class="row-detail">
          <span class="text-subtitle2 bg-ice box-label">
            {{ $gettext("CORRECTED_TOTAL") }}:
            <span class="text-subtitle1">{{
              $toLocaleStringBr(cardsDetail.correctedTotal.totalValue)
            }}</span>
          </span>
        </div>
        <div class="row-detail">
          <span class="text-subtitle2 box-label">
            {{ $gettext("INTEREST_VALUE") }}:
            <span class="text-subtitle1">{{
              cardsDetail.correctedTotal.fees
            }}</span>
          </span>
        </div>
        <div class="row-detail">
          <span class="text-subtitle2 bg-ice box-label">
            {{ $gettext("PENALTY_VALUE") }}:
            <span class="text-subtitle1">{{
              cardsDetail.correctedTotal.fine
            }}</span>
          </span>
        </div>
        <div class="row-detail">
          <span class="text-subtitle2 box-label">
            {{ $gettext("CORRECTION_VALUE") }}:
            <span class="text-subtitle1">{{ cardsDetail.correctedTotal.correction}}</span>
          </span>
        </div>
        <div class="row-detail observation">
          <span class="text-subtitle2 bg-ice box-label"> </span>
        </div>
      </div>
      <div class="tw-w-1/3 custom-border tw-p-2">
        <div class="row-detail">
          <span class="text-subtitle2 bg-ice box-label">
            {{ $gettext("ORIGINAL_TOTAL") }}:
            <span class="text-subtitle1">{{
              $toLocaleStringBr(cardsDetail.originalTotal.totalValue)
            }}</span>
          </span>
        </div>
        <div class="row-detail">
          <span class="text-subtitle2 box-label">
            {{ $gettext("AMOUNT_OF_FEES") }}:
            <span class="text-subtitle1">{{
              cardsDetail.originalTotal.numberInvoices
            }}</span>
          </span>
        </div>
        <div class="row-detail">
          <span class="text-subtitle2 bg-ice box-label">
            {{ $gettext("INTEREST_DISCOUNT_VALUE") }}:
            <span class="text-subtitle1">{{
              cardsDetail.originalTotal.interestDiscount
            }}</span>
          </span>
        </div>
        <div class="row-detail">
          <span class="text-subtitle2 box-label">
            {{ $gettext("FINE_DISCOUNT_VALUE") }}:
            <span class="text-subtitle1">{{
              cardsDetail.originalTotal.fineDiscount
            }}</span>
          </span>
        </div>
        <div class="row-detail observation bg-">
          <span class="text-subtitle2 bg-ice box-label">
            {{ $gettext("CORRECTION_DISCOUNT_VALUE") }}:
            <span class="text-subtitle1">{{
              cardsDetail.originalTotal.correctionDiscount
            }}</span>
          </span>
        </div>
      </div>
      <div class="tw-w-1/3 bg- custom-border tw-p-2">
        <div class="row-detail">
          <span class="text-subtitle2 bg-ice box-label">
            {{ $gettext("FULL_INSTALLMENT") }}:
            <span class="text-subtitle1">{{
              $toLocaleStringBr(
                cardsDetail.fullInstallment.fullInstallmentsValue
              )
            }}</span>
          </span>
        </div>
        <div class="row-detail">
          <span class="text-subtitle2 box-label">
            {{ $gettext("NUMBER_OF_INSTALLMENTS") }}:
            <span class="text-subtitle1">{{
              cardsDetail.fullInstallment.installmentQuantity
            }}</span>
          </span>
        </div>
        <div class="row-detail">
          <span class="text-subtitle2 bg-ice box-label">
            {{ $gettext("INTEREST_INSTALLMENT") }}:
            <span class="text-subtitle1">{{
              $toLocaleStringBr(
                cardsDetail.fullInstallment.feelsInstallmentValue
              )
            }}</span>
          </span>
        </div>
        <div class="row-detail">
          <span class="text-subtitle2 box-label">
            {{ $gettext("TOTAL_DISCOUNTS") }}:
            <span class="text-subtitle1">{{
              $toLocaleStringBr(cardsDetail.fullInstallment.totalDiscount)
            }}</span>
          </span>
        </div>
        <div class="row-detail observation">
          <span class="text-subtitle2 bg-ice box-label">
            {{ $gettext("INSTALLMENT_VALUE") }}:
            <span class="text-subtitle1">{{
              $toLocaleStringBr(cardsDetail.fullInstallment.installmentValue)
            }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtInput } from 'jtech-webcomps'
import NegotiationController from '../NegotiationController'

const REPOSITORY_ACTIONS = {
  RECALCULATE_AGREEMENT_INVOICE: 'agreementInvoice.recalculateAgreementInvoice'
}

@Component({
  name: 'InvoiceSelectedSteep',
  components: {
    JtDataTable,
    JtInput
  },
  props: {}
})
class NegotiationFormSteep extends Vue {
  negotiationController = NegotiationController.getInstance();
  cardsDetail = {
    correctedTotal: {
      totalValue: 0,
      fees: 0,
      fine: 0
    },
    originalTotal: {
      totalValue: 0,
      numberInvoices: this.invoices.length,
      interestDiscount: 0,
      fineDiscount: 0,
      correctionDiscount: 0
    },
    fullInstallment: {
      fullInstallmentsValue: 0,
      installmentQuantity: 0,
      feelsInstallmentValue: 0,
      totalDiscount: 0,
      installmentValue: 0
    }
  };

  isInvalidFineDiscount () {
    return this.dadosForm.fineDiscount < 0 || this.dadosForm.fineDiscount > 100
  }

  isInvalidCorrectionDiscount () {
    return this.dadosForm.correctionDiscount < 0 || this.dadosForm.correctionDiscount > 100
  }

  isInvalidInterestDiscount () {
    return (
      this.dadosForm.interestDiscount < 0 ||
      this.dadosForm.interestDiscount > 100
    )
  }

  isInvalidInstallmentQuantity () {
    return !this.dadosForm.installmentQuantity
  }

  isInvalidFirstInstallmentDue () {
    return !this.dadosForm.firstInstallmentDue
  }

  mounted () {
    this.recalculateCardDetailOriginalTotal()
    this.recalculateCardDetailCorrectedTotal()
    this.negotiationController.setDisabledContinue(true)
  }

  get invoices () {
    return this.negotiationController.getInvoices()
  }

  recalculate () {
    if (this.isValidForm()) {
      this.recalculateCardDetailOriginalTotal()
      this.recalculateCardDetailCorrectedTotal()
      this.recalculateCardDetailInstallment()
      this.negotiationController.setDisabledContinue(false)
    } else {
      this.$jt.messageBox.warn(this.$gettext('FILL_THE_FORM'))
    }
  }

  isValidForm () {
    return (
      this.isInvalidInstallmentQuantity || this.isInvalidFirstInstallmentDue
    )
  }

  blurPorcent (value, inputName) {
    if (value < 0 || value > 100) {
      this.dadosForm[inputName] = undefined
    }
  }

  /**
   * Main function
   * Orchestrates the API call and card updates.
   */
  async recalculateCardDetailInstallment () {
    try {
      const params = this.getRecalculationParams()
      const result = await this.$jt.repository.resolveLogic(
        REPOSITORY_ACTIONS.RECALCULATE_AGREEMENT_INVOICE,
        params
      )
      this.updateAllCards(result)
    } catch (error) {
      console.error('Erro ao recalcular parcelas do acordo:', error)
      this.$jt.messageBox.error(this.$gettext('ERROR_RECALCULATING_INSTALLMENTS'), error.message)
    }
  }

  /**
   * Extracts the parameter construction for the API.
   */
  getRecalculationParams () {
    return {
      totalValue: this.cardsDetail.correctedTotal.totalValue,
      installmentQuantity: this.dadosForm.installmentQuantity,
      firstInstallmentDue: this.dadosForm.firstInstallmentDue,
      invoiceIds: this.invoices.map((i) => i.id),
      interestDiscountPercentage: this.dadosForm.interestDiscount,
      fineDiscountPercentage: this.dadosForm.fineDiscount,
      correctionDiscountPercentage: this.dadosForm.correctionDiscount
    }
  }

  /**
   * Update all cards
   * Groups all post-calculation state updates.
   */
  updateAllCards (result) {
    this.updateFullInstallmentCard(result)
    this.updateOriginalTotalCard(result)
    this.updateCorrectedTotalCard(result)
    this.negotiationController.setInvoicesDetail(result.installmentValueDetails)
  }

  /**
   * Updates the full installment card.
   */
  updateFullInstallmentCard (result) {
    this.cardsDetail.fullInstallment = {
      ...this.cardsDetail.fullInstallment,
      installmentQuantity: this.dadosForm.installmentQuantity,
      fullInstallmentsValue: result.totalValue,
      feelsInstallmentValue: result.totalInterest,
      installmentValue: result.installmentValue,
      totalDiscount: result.totalDiscounts
    }
  }

  /**
   * Updates the original total card with the applied discounts.
   */
  updateOriginalTotalCard (result) {
    this.cardsDetail.originalTotal = {
      ...this.cardsDetail.originalTotal,
      interestDiscount: this.$toLocaleStringBr(result.totalDiscountFees),
      fineDiscount: this.$toLocaleStringBr(result.totalDiscountFine),
      correctionDiscount: this.$toLocaleStringBr(result.totalDiscountCorrection)
    }
  }

  /**
   * Updates the corrected total card.
   */
  updateCorrectedTotalCard (result) {
    const correctedValues = this.calculateCorrectedValues(result)

    this.cardsDetail.correctedTotal = {
      ...this.cardsDetail.correctedTotal,
      totalValue: correctedValues.totalValue,
      fees: this.$toLocaleStringBr(correctedValues.fees),
      fine: this.$toLocaleStringBr(correctedValues.fine),
      correction: this.$toLocaleStringBr(correctedValues.correction)
    }
  }

  /**
   * Calculates the net corrected values (Gross - Discount).
   */
  calculateCorrectedValues (result) {
    return {
      totalValue: result.totalValue - result.totalInterest,
      fees: result.totalFees - result.totalDiscountFees,
      fine: result.totalFine - result.totalDiscountFine,
      correction: result.totalCorrection - result.totalDiscountCorrection
    }
  }

  recalculateCardDetailCorrectedTotal () {
    const initialValue = 0
    const totalValue = this.invoices.reduce((accumulator, invoice) => {
      const valor = parseFloat(
        invoice.newValue
          ? invoice.newValue.replace(',', '.')
          : invoice.remainingDebtValue.replace(',', '.')
      )
      return accumulator + valor
    }, initialValue)

    const initialFeelsValue = 0
    const totalFeelsValue = this.invoices.reduce((accumulator, invoice) => {
      const feelsValue = parseFloat(invoice.feelsValue)
      return isNaN(feelsValue) ? accumulator : accumulator + feelsValue
    }, initialFeelsValue)

    const initialValueFine = 0
    const totalFineValue = this.invoices.reduce((accumulator, invoice) => {
      const fineValue = parseFloat(invoice.fineValue)
      return isNaN(fineValue) ? accumulator : accumulator + fineValue
    }, initialValueFine)

    const initialValueCorrection = 0
    const totalCorrectionValue = this.invoices.reduce((accumulator, invoice) => {
      const correctionValue = parseFloat(invoice.correctionValue)
      return isNaN(correctionValue) ? accumulator : accumulator + correctionValue
    }, initialValueCorrection)

    this.cardsDetail.correctedTotal = {
      totalValue: totalValue,
      fees: this.$toLocaleStringBr(totalFeelsValue),
      fine: this.$toLocaleStringBr(totalFineValue),
      correction: this.$toLocaleStringBr(totalCorrectionValue),
      interestNumber: totalFeelsValue,
      fineNumber: totalFineValue,
      correctionNumber: totalCorrectionValue

    }
  }

  blockContinueSteep () {
    this.negotiationController.setDisabledContinue(true)
  }

  recalculateCardDetailOriginalTotal () {
    const initialValue = 0
    const totalValue = this.invoices.reduce((accumulator, invoice) => {
      const valor = parseFloat(invoice.remainingDebtValue.replace(',', '.'))
      return accumulator + valor
    }, initialValue)

    this.cardsDetail.originalTotal = {
      totalValue: totalValue,
      numberInvoices: this.invoices.length
    }
  }

  get dadosForm () {
    return this.negotiationController.getDadosForm()
  }
}

export default NegotiationFormSteep
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";

.row-detail {
  display: flex;
  height: auto;
  min-height: 30px;
  width: 100%;
  align-items: center;
  padding: 4px 0;
}
.box-label {
  width: 100%;
  padding-left: 10px;
  word-break: normal;
  overflow-wrap: break-word;
  line-height: 1.4;
}

.custom-border {
  border: 0.5px solid #ccc;
  border-radius: 4px;
  min-height: 200px;
}

.tw-flex.tw-gap-6.tw-p-4 {
  margin-bottom: 2rem;
}

@media (max-width: 1400px) {
  .tw-flex.tw-gap-6 {
    gap: 1rem;
  }

  .box-label {
    font-size: 0.875rem;
    padding-left: 8px;
  }

  .text-subtitle1 {
    font-size: 0.875rem;
  }

  .text-subtitle2 {
    font-size: 0.8125rem;
  }
}

@media (max-width: 1366px) {
  .custom-border {
    padding: 0.5rem !important;
  }

  .row-detail {
    min-height: 28px;
    padding: 2px 0;
  }
}
</style>
